<template>

    <div :style="{ height: size + 'px', width: size + 'px' }" v-if="showLottie">

        <lottie
            :options="defaultOptions"
            v-on:animCreated="handleAnimation"
        />

    </div>

</template>

<script>

import Lottie from 'vue-lottie'

export default {

    name: 'lottie-loader',

    components: {Lottie},

    props: {

        size: {
            type: Number,
            default: 40
        }
    },

    data() {
        return {
            defaultOptions: {
                animationData: null
            },
            anim: null,
            showLottie: false
        }
    },

    mounted() {
        this.$http.get('/img/lottie/loader/data-loader.json').then((data) => {
            this.defaultOptions.animationData = data.body
            this.showLottie = true
        })
    },

    methods: {

        handleAnimation: function (anim) {
            this.anim = anim
        },

        stop: function () {
            this.anim.stop()
        },

        play: function () {
            this.anim.play()
        },

        pause: function () {
            this.anim.pause()
        },

        onSpeedChange: function () {
            this.anim.setSpeed(this.animationSpeed)
        }
    }

}

</script>

<style lang="scss" scoped></style>
